@import '~style-sheet-helpers/core.less';

.validate-links {
  display: flex;
  height: 30px;
}
